module.exports = "//public.zight.com/packs/media/images/spinner-822925ba7426b9738d6a22d8e8461814.svg";